import {
    UPDATE_CUSTOMER_DEMO_REQUEST,
    UPDATE_CUSTOMER_DEMO_SUCCESS,
    UPDATE_CUSTOMER_DEMO_FAILURE,
  } from '../../../../Constants/actionTypes';
  
  const initialState = {
    loading: false,
    success: false,
    error: null,
    data: null,
  };
  
  const customerDemoReducer = (state = initialState, action) => {
    switch (action.type) {
      case UPDATE_CUSTOMER_DEMO_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
  
      case UPDATE_CUSTOMER_DEMO_SUCCESS:
        return {
          ...state,
          loading: false,
          success: true,
          data: action.payload,
        };
  
      case UPDATE_CUSTOMER_DEMO_FAILURE:
        return {
          ...state,
          loading: false,
          success: false,
          error: action.payload,
        };
  
      default:
        return state;
    }
  };
  
  export default customerDemoReducer;
  